import * as requestFromServer from "./serviceProviderAppointmentsApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";

// service provider appointments -> get service provider appointments api
export const getServiceProviderAppointmentsAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderAppointments(
      dataToBeSent
    );
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_SERVICE_PROVIDER_APPOINTMENTS_LIST, {
          serviceProviderAppointments: response,
        })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider appointments -> get service provider appointments info by id api
export const getServiceProviderAppointmentsInfoByIdAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response =
      await requestFromServer.getServiceProviderAppointmentsInfoById(
        dataToBeSent
      );
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider and staff -> complete appointment api
export const completeAppointmentAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.completeAppointment(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider and staff -> update package service api
export const updatePackageServiceStatusAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updatePackageServiceStatus(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider appointments -> create service provider appointment api
export const createServiceProviderAppointmentAction =
  (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createServiceProviderAppointment(
      dataToBeSent
    );
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider appointments -> check service availability api
export const checkServiceAvailabilityAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.checkServiceAvailability(
      dataToBeSent
    );
    if (response) {
      dispatch(Actions.createAction(Actions.GET_SERVICE_SELECT_LIST_BASED_ON_AVAILABILITY,{serviceSelectListBasedOnAvailability:response}))
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider appointments -> check service availability api
export const checkStaffAvailabilityAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.checkStaffAvailability(
      dataToBeSent
    );
    if (response) {
      dispatch(Actions.createAction(Actions.GET_STAFF_SELECT_LIST_BASED_ON_AVAILABILITY,{staffSelectListBasedOnAvailability:response}))
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider appointments -> update service provider appointment order status api
export const updateServiceProviderAppointmentOrderStatusAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response =
      await requestFromServer.updateServiceProviderAppointmentOrderStatus(
        dataToBeSent
      );
    if (response) {
      toastService.success("Appointment Status updated successfully");
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider appointments -> update service provider appointment customer documents api
export const uploadServiceProviderAppointmentCustomerDocumentsAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response =
      await requestFromServer.uploadServiceProviderAppointmentCustomerDocuments(
        dataToBeSent
      );
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const createServiceInfoAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createServiceInfo(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const deleteServiceInfoAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.deleteServiceInfo(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const updateServiceInfoAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateServiceInfo(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// staff -> get available staff for appointment select api
export const getAvailableStaffForAppointmentAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading({
      status: true,
      id: dataToBeSent.orderId,
      serviceId:
        dataToBeSent.order_type === "package" ? dataToBeSent.service_id : null,
    });

    const response = await requestFromServer.getAvailableStaffForAppointment(
      dataToBeSent
    );

    setLoading({ status: false, id: null, serviceId: null });
    dispatch(Actions.createAction(Actions.GET_REQUEST_STAFF_LIST, response));

    return response;
  };
